module.exports = __webpack_public_path__ + "img/豆浆粉.73b140a4.png";